import { MD5_SALT } from "Constant";

const md5 = require("md5");

export function generatePassAppHash(str, newSalt) {
  const salt = newSalt ? newSalt : MD5_SALT;
  return md5(str + salt);
}
